import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class SqlModeService {
  private fixButtonVisible = new BehaviorSubject<boolean>(false);
  fixButtonVisible$ = this.fixButtonVisible.asObservable();
   
   // 👇 backend ka API base URL
  private sqlModeURL = environment.serverUrl + '/host/fix-sql-mode';

  constructor(private http: HttpClient) {}

  // Button ko show karna
  showFixButton() {
    this.fixButtonVisible.next(true);
  }

  // Button ko hide karna
  hideFixButton() {
    this.fixButtonVisible.next(false);
  }

    // 🔹 Ye naya method hai → state ko reset karega
  reset() {
    this.fixButtonVisible.next(false);
  }

  // Backend ko call karna
  fixSqlMode() {
    return this.http.post(this.sqlModeURL, {}); 
  }
}
